<section class="section-div">
  <div class="content-details">
    <div class="title-details">
      <div class="mobil-res">
        <h4><ion-icon name="receipt-outline"></ion-icon> Incubatee List</h4>
        <div class="ml-auto">
          <button
            mat-raised-button
            color="primary"
            (click)="eventAddBtn('Add')"
          >
            Add Incubatee
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="noData == false">
      <div class="download-div">
        <button mat-raised-button color="accent" (click)="downloadExcel()">
          Download Excel <ion-icon name="cloud-download-outline"></ion-icon>
        </button>
      </div>
      <div class="example-container mat-elevation-z8">
        <mat-table #table [dataSource]="dataSource" [class.isMobile]="isMobile">
          <ng-container matColumnDef="index">
            <mat-header-cell
              *matHeaderCellDef
              class="table-no"
              style="max-width: 150px"
            >
              No.
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element; let i = index"
              class="table-no"
              style="max-width: 150px"
            >
              <span class="mobile-label">No :</span>
              {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="incubateeName">
            <mat-header-cell *matHeaderCellDef> Incubatee Name</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label"> Incubatee Name:</span>
              {{ element.incubateeName }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef>Email Id</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label">Email Id:</span>
              {{ element.email }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="phone">
            <mat-header-cell *matHeaderCellDef>Phone Number</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label">Phone Number:</span>
              {{ element.phone }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="founderName">
            <mat-header-cell *matHeaderCellDef> Founder Name</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label"> Founder Name:</span>
              {{ element.founderName }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="registeredDate">
            <mat-header-cell *matHeaderCellDef>
              Registered Date</mat-header-cell
            >
            <mat-cell *matCellDef="let element">
              <span class="mobile-label"> Registered Date:</span>
              {{ element.registeredDate }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label">Action:</span>
              <mat-icon
                class="edit-i"
                (click)="editIncubatee('Update', element.id)"
              >
                edit</mat-icon
              >
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>

      <mat-paginator
        #paginator
        class="mat-elevation-z8"
        [length]="pageTotalCount"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 15, 20]"
        showFirstLastButtons
        (page)="getServerData($event)"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </div>
    <div class="text-center no-data-div" *ngIf="noData == true">
      <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
      <h6>No Records Found</h6>
    </div>
  </div>
</section>
